import { render, staticRenderFns } from "./ExportDeclarationDownload.vue?vue&type=template&id=307b4605&"
import script from "./ExportDeclarationDownload.vue?vue&type=script&lang=js&"
export * from "./ExportDeclarationDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports